export default __webpack_public_path__ + "static/media/480_business02-fr-web.bb6da5ea.png";